/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Driverremittance_Reason_Placeholder1Inputs */

const vi_driverremittance_reason_placeholder1 = /** @type {(inputs: Driverremittance_Reason_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập lý do (tài xế sẽ thấy)`)
};

/**

* @param {Driverremittance_Reason_Placeholder1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const driverremittance_reason_placeholder1 = /** @type {((inputs?: Driverremittance_Reason_Placeholder1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Driverremittance_Reason_Placeholder1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_driverremittance_reason_placeholder1(inputs)
});
export { driverremittance_reason_placeholder1 as "driverRemittance_reason_placeholder" }